import { lv } from 'date-fns/locale'

export const MAX_CHALLENGES = 6
export const ALERT_TIME_MS = 3000
export const LONG_ALERT_TIME_MS = 10000
export const REVEAL_TIME_MS = 350
export const WELCOME_INFO_MODAL_MS = 350
export const DISCOURAGE_INAPP_BROWSERS = true
export const ENABLE_MIGRATE_STATS = true
export const BLOWFISH_KEY = 'bz82)XagJ#A)WqX#/DO%sDdaV!o4%q&!'
export const BLOWFISH_IV = '4u9*cN&f'
export const ENABLE_ARCHIVED_GAMES = true
export const DATE_LOCALE = lv
